import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, loginPathFor } from '@onvice/portal-shell-api';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  adminOnly?: boolean;
}

export default function ProtectedRoute({ children, adminOnly = false }: Props) {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-950">
        <div className="w-8 h-8 border-2 border-brand-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Ziel als ?next= mitgeben — nach der Anmeldung geht es dorthin zurück
  // (Holger-Fund 2026-09-17: Ticket-Link aus Mail landete auf der Startseite).
  if (!isAuthenticated) return <Navigate to={loginPathFor(`${location.pathname}${location.search}${location.hash}`)} replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;

  return <>{children}</>;
}
